import React, { Component } from "react";
import { compose, withState, withActions } from "containers/HOC";
import { withRouter } from "react-router-dom";
import AnalysisDetails from "./AnalysisDetails";
import { modalInlineClose, modalInlineOpen } from "containers/App/_actions";
import { fetchBudget } from "containers/Budget/_actions";
import { editDatasetFarm, executeAnalysis } from "./_actions";
import Page from "components/Page";
import PageBody from "components/PageBody";
import * as datasetUtils from "./_utils";

class AnalysisEdit extends Component {
    render() {
        if (!this.props.farmViewModel) return null;
        return (
            <Page>
                <PageBody>
                    <AnalysisDetails {...this.props} isNew={true} onSave={this.props.editDatasetFarm} executeAnalysis={this.props.executeAnalysis} />
                </PageBody>
            </Page>
        );
    }
}

export default compose(
    withRouter,
    withState((state, ownProps) => {
        if (!ownProps.budget.blocks) return null;
        const analysis = ownProps.budget;
        const { blocks = [] } = analysis;
        if (blocks.length === 0) {
            analysis.blocks = blocks;
            analysis.blocks.push(datasetUtils.createEmptyBlock("Block 1"));
        }
        return {
            auth: state.auth,
            online: state.app.online,
            currentDataset: state.dataset.currentDataset,
            datasetId: ownProps.match.params.datasetId,
            isLoading: state.app.isLoading,
            smapReferenceResults: state.searchResults.smapReferenceResults,
            refData: state.app.refData,
            farmViewModel: { farm: ownProps.farm, analysis: datasetUtils.analysisViewModel(analysis) },
            modelledResults: state.dataset.modelledResults,
        };
    }),
    withActions({ modalInlineClose, modalInlineOpen, editDatasetFarm, fetchBudget, executeAnalysis })
)(AnalysisEdit);
